import { useCallback, useMemo } from 'react';
import { AppDispatch } from 'store/store';
import { useDispatch } from 'react-redux';
import {
	setDialogSubmitClaimOpen,
	SubmitClaimMappingPayload,
	setInjectionState,
} from 'feature/hooks/submitClaimSlice';

const useDialogSubmitClaim = () => {
	const dispatch = useDispatch<AppDispatch>();

	const closeDialogSubmitClaim = useCallback(() => {
		dispatch(setDialogSubmitClaimOpen(false));
	}, [dispatch]);

	const handleOpen = useCallback(
		(payload: SubmitClaimMappingPayload) => {
			dispatch(setInjectionState(payload));
			dispatch(setDialogSubmitClaimOpen(true));
		},
		[dispatch],
	);

	return useMemo(
		() => ({
			open: handleOpen,
			close: closeDialogSubmitClaim,
		}),
		[handleOpen, closeDialogSubmitClaim],
	);
};

export default useDialogSubmitClaim;
